export default {"src":"/_next/static/media/github.1290de3d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};